var m = require("mithril");
var BroadCastChannel = require("./broadcastChannel");

// Shared global variables and channel setup:
const bindingChannel = new BroadCastChannel('copyBindingChannel');

// Try to load any persisted binding data from localStorage.
if (localStorage.getItem("gojsBindingClipboard") && Object.keys(JSON.parse(localStorage.getItem("gojsBindingClipboard"))).length > 0) {
  window.latestBindingData = JSON.parse(localStorage.getItem("gojsBindingClipboard"));
  console.log("Loaded persisted binding data from localStorage:", window.latestBindingData);
}

// Listen for copy messages from other windows.
bindingChannel.onMessage((data) => {
  if (data.type === "copyBinding") {
    window.latestBindingData = data.data;
    
    // Persist the data so newly opened windows can see it.
    localStorage.setItem("gojsBindingClipboard", JSON.stringify(window.latestBindingData));
    // Redraw or update UI as needed (using Mithril's m.redraw or similar).
    m.redraw();
    console.log("Received binding data via BroadcastChannel:", window.latestBindingData);
  }
});

module.exports = { bindingChannel } // Export the bindingChannel instance for use in other modules
